import * as Sentry from '@sentry/vue';
import { SentryConfig } from '@/shared/constants/SentryConfig';
import ConfigService from '@/shared/services/ConfigService';
import AuthService from './AuthService';

class SentryService {
  init(app: any, router: any) {
    const environment = ConfigService.get('ENVIRONMENT') || import.meta.env.MODE;
    Sentry.init({
      app,
      dsn: SentryConfig.DSN,
      integrations: [Sentry.browserTracingIntegration({ router })],
      tracesSampleRate: 1.0,
      enabled: environment !== 'local' && environment !== 'development',
      environment,
      release: import.meta.env.APP_VERSION,
    });
  }

  captureException(error: Error) {
    Sentry.captureException(error);
  }

  setUser(user: { id: string; name: string }) {
    Sentry.setUser({
      id: user.id,
      name: user.name,
    });
  }

  loadUser() {
    if (AuthService.isAuthenticated()) {
      const user = AuthService.getCurrentUser();
      this.setUser({
        id: `${user.id}`,
        name: `${user.name}`,
      });
    }
  }

  clearUser() {
    Sentry.setUser(null);
  }
}

export default new SentryService();
